import {BrowserRouter, Route, Routes, useNavigate} from 'react-router-dom';
import OverviewPage from './pages/OverviewPage';
import DetailPage from './pages/DetailPage';
import {useSettingsContext} from './context/settings/useSettingsContext';
import {useEffect, useState} from 'react';

const AppRouter = () => {
    const { basePath } = useSettingsContext();

    return (
        <BrowserRouter basename={basePath}>
            <AppRoutes/>
        </BrowserRouter>
    )
}

const AppRoutes = () => {
    const navigate = useNavigate();
    const { redirectPath } = useSettingsContext();
    const [shouldRenderRoutes, setShouldRenderRoutes] = useState(false);

    // If redirectPath exists, redirect to the corresponding route first.
    useEffect(() => {
        if (redirectPath) {
            navigate(`/${redirectPath}`);
        }
        setShouldRenderRoutes(true);
    }, [navigate, redirectPath]);

    return shouldRenderRoutes ? (
        <Routes>
            <Route index path="/" element={<OverviewPage/>}/>
            <Route path='/:pageUrl' element={<DetailPage/>}/>
        </Routes>
    ) : null;
}

export default AppRouter;
